import { UIComponent } from "@aptus/frontend-core";
import { Private } from "components/private";
import {
	usePageTitles,
	useRoutes,
} from "domains";
import { useAuthenticationEffects } from "hooks/authentication/useAuthenticationUseCases";
import { usePageTitleEvents } from "hooks/pageTitle/models/usePageTitleUseCases";
import { useRoutesEffects } from "hooks/routes/useRoutesUseCases";
import { BackgroundPage } from "pages/background/backgroundPage";
import { ForgotTagIdPage } from "pages/forgotTagId/forgotTagId";
import { HeaderPage } from "pages/header/headerPage";
import { LoginPage } from "pages/login/loginPage";
import { PasswordResetPage } from "pages/passwordReset/passwordResetPage";
import { BiketagStep } from "pages/register/pages/biketagStep/biketagStep";
import { ClassroomStep } from "pages/register/pages/classroomStep/classroomStep";
import { OverviewStep } from "pages/register/pages/overviewStep/overviewStep";
import { PasswordStep } from "pages/register/pages/passwordStep/passwordStep";
import { SchoolStep } from "pages/register/pages/schoolStep/schoolStep";
import { QuestionsStep } from "pages/register/pages/questionsStep/questionsStep";
import { WristbandStep } from "pages/register/pages/wristbandStep/wristbandStep";
import { RegisterPage } from "pages/register/registerPage";
import { RegistrationDonePage } from "pages/registrationDone/registrationDonePage";
import { RequestPasswordResetPage } from "pages/requestPasswordReset/requestPasswordResetPage";
import { Navigate, Route, Routes } from "react-router-dom";
import { formatImageUrl } from "utils/formatImageUrl";
import { HomePage } from "./pages/home/homePage";

/**
 * This is the router of the application.
 * It handles everything that is based on the "Router state" (URL).
 * This enforces consistency on how URLs are handled throughout the application.
 */

export const Content: UIComponent = () => {
	const pageTitles = usePageTitles();
	usePageTitleEvents(pageTitles);

	const { routes } = useRoutes();
	useRoutesEffects(useRoutes());
	useAuthenticationEffects();

	const isAuthorized = !!(window.environment?.anonymousToken);

	return (
		<Routes>
			<Route path="*" element={<Navigate to={routes.index} />} />
			<Route element={<BackgroundPage backgroundImage={formatImageUrl("/five-space-background.png")} />}>
				<Route element={<HeaderPage />}>
					<Route path={routes.index} element={<HomePage />} />
					<Route path={routes.register.done} element={<RegistrationDonePage />} />
				</Route>
			</Route>
			<Route element={<BackgroundPage backgroundImage={formatImageUrl("/five-space-background.png")} />}>
				<Route element={<HeaderPage />}>
					<Route path={routes.login} element={<LoginPage />} />
					<Route path={routes.passwordReset} element={<PasswordResetPage />} />
					<Route path={routes.requestPasswordReset} element={<RequestPasswordResetPage />} />
					<Route
						path={routes.register.index}
						element={(
							<Private isAuthorized={isAuthorized} redirectTo={routes.index}>
								<RegisterPage />
							</Private>
						)}
					>
						<Route index element={<Navigate to={routes.register.stepOne} />} />
						<Route path={routes.register.stepOne} element={<WristbandStep />} />
						<Route path={routes.register.stepTwo} element={<BiketagStep />} />
						<Route path={routes.register.stepThree} element={<SchoolStep />} />
						<Route path={routes.register.stepFour} element={<ClassroomStep />} />
						<Route path={routes.register.stepFive} element={<PasswordStep />} />
						<Route path={routes.register.stepSix} element={<QuestionsStep />} />
						<Route path={routes.register.stepSeven} element={<OverviewStep />} />
					</Route>
					<Route path={routes.forgotTagId} element={<ForgotTagIdPage />} />
				</Route>
			</Route>
		</Routes>
	);
};
